import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from './BaseEditExtension.js';

@Entity()
export class BaseGeneralEditCRMFlagsExtension extends BaseEditExtension {
  static override _class = 'BaseGeneralEditCRMFlagsExtension';
}
